<template lang="pug">
include /@ibkr/lib.common/src/icon/basic
include /@ibkr/lib.common/src/icon/arrow
include /@ibkr/lib.common/src/icon/color
ib-dialog(v-model="show", autoclose,  width="50%", height="50%", class="comp-dialog")
    template(slot="default")
        div(class="product-details", v-if="apiStatus === 'results'")
            div(class="headers")
                div(class="")
                    div(class="product-description")
                        h4 {{ productdescription }}
                    div(class="product-symbol")
                        h3 {{ productSymbol }}
            div(class="trading-info")
                div(class="trading-date end-16", v-if="isCFD === false")
                    h6 LAST TRADING DATE
                    ib-dropdown(
                        v-model="lastTradingDate",
                        :data="expirationData",
                        width="100%"
                        align="start",
                        filtered
                    )
                div(v-if="isFuture === false", class="trading-date end-16")
                    h6 STRIKES
                    ib-dropdown(
                        v-model="latestStrikePrice",
                        :data="strikesData",
                        width="100%",
                        align="start"
                        filtered
                    )
                div(v-if="isFuture === false", class="trading-date end-16")
                    h6 CALL/PUT
                    ib-dropdown(
                        v-model="callOrPut",
                        :data="putOrCallData",
                        width="100%",
                        align="start",
                        filtered
                    )
            div(class="instruments")
                div(class="instruction")
                    span(class="instrument-indicator")
                        +icon-arrow-left_down2_filled   
                    h5(v-if="isFuture === false") Select an instrument below
                    h5(v-if="isFuture === true") Class

                ib-button(
                    v-for = "(description, index) in descriptionData",
                    :key="index",
                    appearance="outline",
                    tone="accent",
                    class="instruction-list",
                    @click="viewContractDetails(description.conid)"
                ) {{description.description}}
            div
                span(class="icon-close", @click="close", ref="reload")
                    +icon-basic-cancel_filled
        div(class="error-message", v-if="apiStatus === 'error'")
            h1(class="msg") Data is not available
            div
                span(class="icon-close", @click="close", ref="reload")
                    +icon-basic-cancel_filled
        div(v-if="apiStatus === 'loading'", class="waiting")
            ib-progress-circular(width="128px", height="128px")
        QuoteDetails(ref="quoteDetails")
</template>

<script>
import api from '../api';
import { mapState, mapActions, mapGetters } from 'vuex';
import QuoteDetails from './QuoteDetails.vue';

export default {
    name: 'SearchProducts',
    components: {
        QuoteDetails,
    },
    data() {
        return {
            show: false,
            isFuture: true,
            isCFD: true,
            productSymbol: '',
            productdescription: '',
            expirationData: [],
            expirations:[],
            strikesData: [],
            putOrCallData: [],
            uniquePutOrCall: [],
            descriptionData: [],
            optionChainResponse: [],
            apiStatus: 'loading',
            lastTradingDate: null,
            latestStrikePrice: null,
            callOrPut: null,
            productType: null,
            months: [
                { name: "Jan", month: "01" },
                { name: "Feb", month: "02" },
                { name: "Mar", month: "03" },
                { name: "Apr", month: "04" },
                { name: "May", month: "05" },
                { name: "Jun", month: "06" },
                { name: "Jul", month: "07" },
                { name: "Aug", month: "08" },
                { name: "Sep", month: "09" },    
                { name: "Oct", month: "10" },
                { name: "Nov", month: "11" },
                { name: "Dec", month: "12" },
            ],
            type: null,
            conid: null,
            underConid: null,
            expirationDateMapping: [],
            secDefResponse: [],
            companyName: null,
            currency: null,
        }
    },
    watch: {
        lastTradingDate(newValue, oldValue) {
            this.latestStrikePrice= null,
            this.callOrPut= null,
            this.strikesData = [];
            this.putOrCallData = [];
            this.uniquePutOrCall = [];
            this.descriptionData = [];
            
            if(this.productType === 'WAR' || this.productType === 'FOP'){
                const newTradingDates = this.expirations.filter(exp => exp.value === newValue).map(exp => exp.date);
                const oldTradingDates = this.expirations.filter(exp => exp.value === oldValue).map(exp => exp.date);
    
                // Method to handle strikes and call/put data
                this.getProductDetails(newTradingDates, oldTradingDates);
            } else if(this.productType === 'FUT'){
                let updatedLastTradingDate = this.expirationDateMapping.filter(expiration => expiration.value === newValue).map(expiration => expiration.date);
                this.secDefResponse.forEach(res => {
                    if(updatedLastTradingDate.includes(res.lastTradingDay)){
                        this.conid = res.conid;
                        if(this.descriptionData.length === 0){
                            this.descriptionData.push({description: this.companyName.replace(/&amp;/g, "&"), conid: res.conid});
                        }
                    }
                })
            }
        },
        latestStrikePrice(newValue, oldValue) {
            const tradingDates = this.expirations.filter(exp => exp.value === this.lastTradingDate).map(exp => exp.date);
            if(oldValue != null){
                this.getInstruments(tradingDates);
            }
        },
        callOrPut(newValue, oldValue) {
            const tradingDates = this.expirations.filter(exp => exp.value === this.lastTradingDate).map(exp => exp.date);
            if(oldValue != null){
                this.getInstruments(tradingDates);
            }
        },
    },
    methods: {
        open(symbol, companyHeader, conid, underConid, type, currency) {
            this.close();
            this.type = type;
            this.underConid = underConid;
            this.productType = type;
            this.companyName = companyHeader;
            this.currency = currency;

            let payload = {
                underConid: underConid,
            }

            if(type === 'FOP'){
                api.getOptionChain(payload)
                    .then(response => {
                        this.optionChainResponse = response.optionChain.sort((a,b) => b.expiration - a.expiration);
    
                        // Sort Expirations in ascending order
                        response.expirations.sort(function(a, b) {
                            return a-b;
                        });                    
    
                        // Populating last trading date dropdown data
                        response.expirations.forEach((res,index) => {
                            let year = res.toString().substring(0,4);
                            let month = this.months.filter(month => month.month === res.toString().substring(4, 6)).map(month => month.name.toUpperCase());
                            let instrument = month[0] + " " + year;
    
                            if(index === 0){
                                this.expirationData.push(month[0] + " " + year);
                                this.expirations.push({date: res, value: month[0] + " " + year});
                            } else if(this.expirations.filter(exp => exp.value === month[0] + " " + year && exp.data === res).length === 0){
                                if(this.expirationData.indexOf(month[0] + " " + year) === -1) {
                                    this.expirationData.push(month[0] + " " + year);
                                }
                                this.expirations.push({date: res, value: month[0] + " " + year});
                            }
                        });
    
                        // Pre-select lastest expiration date in dropdown. This will trigger a watcher which populates data related to lastTradingDate
                        this.lastTradingDate = this.expirations[0].value;

                        this.isFuture = false;
                        this.isCFD = false;
    
                    })
                    .catch(e => {
                        this.apiStatus = 'error';
                    })
    
            } else if(type === "WAR") {
                api.getWarrantOptionChain(payload)
                    .then(response => {
                        this.optionChainResponse = response.optionChain.sort((a,b) => b.expiration - a.expiration);
    
                        // Sort Expirations in ascending order
                        response.expirations.sort(function(a, b) {
                            return a-b;
                        });                    
    
                        // Populating last trading date dropdown data
                        response.expirations.forEach((res,index) => {
                            let year = res.toString().substring(0,4);
                            let month = this.months.filter(month => month.month === res.toString().substring(4, 6)).map(month => month.name.toUpperCase());
                            let instrument = month[0] + " " + year;
    
                            if(index === 0){
                                this.expirationData.push(month[0] + " " + year);
                                this.expirations.push({date: res, value: month[0] + " " + year});
                            } else if(this.expirations.filter(exp => exp.value === month[0] + " " + year && exp.data === res).length === 0){
                                if(this.expirationData.indexOf(month[0] + " " + year) === -1) {
                                    this.expirationData.push(month[0] + " " + year);
                                }
                                this.expirations.push({date: res, value: month[0] + " " + year});
                            }
                        });
    
                        // Pre-select lastest expiration date in dropdown. This will trigger a watcher which populates data related to lastTradingDate
                        this.lastTradingDate = this.expirations[0].value;

                        this.isFuture = false;
                        this.isCFD = false;
    
                    })
                    .catch(e => {
                        this.apiStatus = 'error';
                    })
            } else if(type === 'FUT') {
                let payload = {
                    productType: type,
                    underConid: underConid,
                }
                api.getContractDetails(payload)
                    .then(response => {
                        this.expirationDateMapping = [];
                        const conids = response.conids.join();

                        api.getSecdefData(conids)
                            .then(response => {
                                this.secDefResponse = response.secdef;
                                response.secdef.forEach(res => {
                                    if(res.lastTradingDay != null){
                                        this.expirations.push(res.lastTradingDay);
                                    }
                                })
                                
                                this.expirations.sort(function(a, b) {
                                    return a-b;
                                })
                                
                                // Populating last trading date dropdown data
                                this.expirations.forEach((res,index) => {
                                    let year = res.toString().substring(0,4);
                                    let month = this.months.filter(month => month.month === res.toString().substring(4, 6)).map(month => month.name);
                                    
                                    if(index === 0){
                                        this.expirationData.push(month[0] + " " + year);
                                        this.expirationDateMapping.push({date: res, value: month[0] + " " + year});
                                    } else {
                                        if(this.expirationData.indexOf(month[0] + " " + year) === -1) {
                                            this.expirationData.push(month[0] + " " + year);
                                            this.expirationDateMapping.push({date: res, value: month[0] + " " + year});
                                        }
                                    }
                                });

                                this.lastTradingDate = this.expirationData[0];
                                response.secdef.forEach(res => {
                                    if(res.lastTradingDay === this.expirationDateMapping[0].date){
                                        this.descriptionData.push({description: companyHeader.replace(/&amp;/g, "&")});
                                    }
                                })
                            })
                        this.apiStatus = 'results';
                        this.isCFD = false;
                    })
            } else if(type === 'CFD') {
                this.conid = conid;
                this.descriptionData.push({description: symbol + " CFD"});
                this.apiStatus = 'results';
            }

            
            this.productdescription = companyHeader.replace(/&amp;/g, "&");
            this.productSymbol = symbol;
            this.show = true;
        },
        getProductDetails(newTradingDates, oldTradingDates) {
            this.optionChainResponse.forEach(res => {
                if(newTradingDates.includes(res.expiration)) {
                    // Populate strike data for latest expiration date
                    if(this.strikesData.indexOf(res.strike) === -1) {
                        this.strikesData.push(res.strike);
                    }

                    // Populate call or put data
                    if(res.putOrCall === 'C' && !this.putOrCallData.includes('Call')){
                        this.putOrCallData.push("Call");
                    } else if(res.putOrCall === 'P' && !this.putOrCallData.includes('Put')){
                        this.putOrCallData.push("Put");
                    }
                }
            })
                    
            // Sort strikes data in descending order
            this.strikesData.sort(function(a, b) {
                return b-a;
            })  
            
            // Pre-select highest strike in stikes dropdown
            const averageStrikePrice = (this.strikesData[0]+this.strikesData[this.strikesData.length -1])/2;
            const selectedStrikePrice = this.strikesData.find(strike => strike <= averageStrikePrice);
            this.latestStrikePrice = selectedStrikePrice

            // Pre-fil call or put value in dropdown
            this.callOrPut = this.putOrCallData[0];

            this.getInstruments(newTradingDates);
        },
        getInstruments(newTradingDates) {
            this.descriptionData = [];
            let descriptionText;
            let option;
            if(this.callOrPut === 'Call'){
                option = 'C';
            } else {
                option = 'P';
            }
            const expirationDate = this.expirations.filter(exp => newTradingDates.includes(exp.date)).map(exp => exp.date);

            this.optionChainResponse.forEach(res => {
                if(expirationDate.includes(res.expiration) && this.latestStrikePrice === res.strike && option === res.putOrCall){
                    this.conid = res.conid;
                    this.underConid = res.underlyingConid;
                }
                const month = this.months.find(month => month.month === res.expiration.toString().substring(4, 6));
                const date = res.expiration.toString().substring(6)
                const year = res.expiration.toString().substring(2, 4);
                if((this.latestStrikePrice == res.strike) && (option === res.putOrCall) && (expirationDate.includes(res.expiration))){
                    if(this.type != "WAR"){
                        descriptionText = "(" + res.localName.substring(0,3) + ") " + month.name + date + "'" + year + " " + res.strike + " " + this.currency + " " + this.callOrPut + " (" + res.multiplier +")";
                    } else {
                        descriptionText = month.name + date + "'" + year + " " + res.strike + " " + this.currency + " " + this.callOrPut + " (" + res.localName + "," + res.multiplier +")";
                    }
                    const description = {description: descriptionText, conid: res.conid};
                    this.descriptionData.push(description);
                }
            })
            
            // Enabling modal with product details
            this.apiStatus = 'results';
        },
        viewContractDetails(conid) {
            if(this.type != 'CFD'){
                console.debug("Parameters for iframe: ", conid, this.underConid, this.type);
                this.$refs.quoteDetails.open(conid, this.underConid, this.type);
            } else {
                this.$refs.quoteDetails.open(this.conid, this.underConid, this.type);
            }
            this.show = false;
        },
        close() {
            this.show = false;
            this.apiStatus = 'loading';
            this.lastTradingDate= null,
            this.latestStrikePrice= null,
            this.callOrPut= null,
            this.strikesData = [];
            this.putOrCallData = [];
            this.uniquePutOrCall = [];
            this.descriptionData = [];
            this.expirations = [];
            this.expirationData = [];
        },
        ...mapActions([])
    },
    computed: {
        ...mapGetters([]),
        ...mapState([])
    }
}
</script>

<style lang="less">
.icon-close {
    position: absolute;
    right: 10px;
    top: 10px;
    svg {
        width: 2rem;
    }
}
.product-details {
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    padding: 1em;
}
.headers {
    display: flex;
    flex-direction: column;
}
.trading-info {
    display: flex;
    flex-direction: row;
    padding-top: 20px;
}
.trading-date {
    width: 100%
}
.instruments {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    padding-top: 20px;
}
h5 {
    text-align: center;
    padding-left: 10px;
    padding-bottom: 10px;
    display: inline-block;
}
.msg {
    text-align: center;
    padding-top: 20px;
    padding: 0px;
}
.waiting {
    position: relative;
    left: 44%;
    top: 17%;
}
.instruction-list {
    border-radius: 30px;
}
.instruction {
    text-align: center;
}
.instrument-indicator{
    svg{
        color: #537dc8;
    }
}
.error-message {
    display: flex;
    width: 100%;
    justify-content: center;
    flex-direction: column;
}
</style>